import React from 'react';

/**
 * Theme toggle button component
 */
export const ThemeToggle = ({ isDarkTheme, onToggle }) => {
  return (
    <button className="theme-toggle" onClick={onToggle}>
      <span className="theme-toggle-icon">{isDarkTheme ? '☀️' : '🌙'}</span>
      <span>{isDarkTheme ? 'Claro' : 'Oscuro'}</span>
    </button>
  );
};
